export const VERIFICATION_STATUSES = {
  COMPLETED: 'Completed',
  PENDING: 'Pending',
  FAILED: 'Failed',
  UNVERIFIED: 'Unverified',
}

export const STATUSES_SETTINGS = {
  [VERIFICATION_STATUSES.PENDING]: {
    title: 'components.promotion.google-business-profile.verify-profile.status.pending.title',
    description: 'components.promotion.google-business-profile.verify-profile.status.pending.description',
    icon: 'hourglass',
    iconColor: 'orange',
  },
  [VERIFICATION_STATUSES.COMPLETED]: {
    title: 'components.promotion.google-business-profile.verify-profile.status.completed.title',
    description: 'components.promotion.google-business-profile.verify-profile.status.completed.description',
    icon: 'tick',
    iconColor: 'green',
  },
  [VERIFICATION_STATUSES.FAILED]: {
    title: 'components.promotion.google-business-profile.verify-profile.status.failed.title',
    description: 'components.promotion.google-business-profile.verify-profile.status.failed.description',
    icon: 'x',
    iconColor: 'red',
  },
}

export const GBP_ENTRY_SOURCE_KEY = 'entry_source'

export const GBP_ENTRY_POINTS = {
  MARKETING: 'marketing',
  IN_APP_NOTIFICATION: 'in_app_notification',
  DEEPLINK: 'deeplink',
  ONBOARDING: 'onboarding',
  PROFILE: 'profile',
}

export const GOOGLE_LOCATIONS_HREF = 'https://business.google.com/locations'

export const CODE_LENGTH = 6

export const GBP_VERIFICATION_METHODS = {
  AUTO: 'AUTO',
  SMS: 'SMS',
  EMAIL: 'EMAIL',
  PHONE_CALL: 'PHONE_CALL',
}
